export default __webpack_public_path__ + "static/media/logo.9a37c2a8.png";